import Vue from 'vue';
import Vuex from 'vuex';
import VueAuthMain from '@telexpress/vue-auth-main';
import authModule from './AuthModule.js';
import companyModule from './CompanyModule.js';
import featureModule from './FeatureModule.js';

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    authModule: authModule.module,
    companyModule: companyModule.module,
    featureModule: featureModule.module,
    ...VueAuthMain.module
  },
  strict: process.env.NODE_ENV === 'development',
  plugins: [authModule.plugin, companyModule.plugin]
});

export default store;
